import script from "./AgentLiveStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentLiveStrip.vue?vue&type=script&setup=true&lang=js"

import "./AgentLiveStrip.vue?vue&type=style&index=0&id=bbb488be&lang=css"

const __exports__ = script;

export default __exports__